import React from "react";
import CreditTerm from "./CreditTerm";

const PendingCreditTermApprovalForSalesDirector = () => {
    return <CreditTerm status="sales-director" type="list" title="Credit term"/>;
};

export default PendingCreditTermApprovalForSalesDirector;
